export default {
    'Version': '流程实例版本号',
    'FinishTime': '完成时间：{time}',
    'CancelTime': '作废时间：{time}',
    'CurNode': '当前节点',
    'CurHandler': '当前处理人',
    'UsedTime': '已用时{time}',
    'WorkflowTrack': '流程跟踪',
    'Edit': '编辑表单',
    'AdjustNode': '调整节点',
    'ProcessOperationAndMaintenance': '流程运维',
    'Nullify': '作废',
    'Delete': '删除',
    'Logs': '操作日志',
    'Finish': '结束',
    'EditOwner': '修改拥有者',
    'NullifyTips': '作废后该流程将停止流转，确定要作废？',
    'NullifyTips1': '确定要作废吗？',
    'NullifyTips2': '作废后该流程将停止流转',
    'DeleteTips1': '流程删除后该流程所有数据将删除，',
    'DeleteTips2': '且删除后不可恢复',
    'DeleteTips3': '确定要删除？',
    'Total': '共{num}条',
    'WorkHandover': '工作交接',
    'organization': '组织机构',
    'organizationTips1': '在职人员和离职人员通过人员、部门查找，进行工作交接',
    'organizationRole': '组织角色',
    'organizationTips2': '通过角色查找，进行工作交接',
    'SelectAction': '选择流程操作',
    'FinishWorkflow': '提前结束流程',
    'FinishWorkflowTips': '确定立即结束流程？',
    'WorkflowChart': '流程图',
    'SmallScreen': '退出全屏',
    'ApprovalLog': '审批日志',
    'Describe': '描述',
    'Back': '返回',
    'OperationLogs': '用户操作日志',
    'NoOperationLogs': '暂无操作日志',
    'View': '查看',
    'DetailInfo': '详情信息',
    'Number': '序号',
    'OperationType': '操作类型',
    'OperationTime': '操作时间',
    'User': '用户',
    'Operations': '操作节点',
    'Platform': '平台',
    'Detail': '详细',
    'Assist': '的协办]',
    'AddWorkitem': '的加签]',
    'Circulate': '的传阅]',
    'Forward': '的转办]',
    'ActivityName': '节点名称',
    'ReceiveTime': '接收时间',
    'FinishTimes': '完成时间',
    'CostTime': '耗时',
    'Originator': '参与者',
    'ApprovalAction': '操作',
    'consignor': '被委托人',
    'FinishNode': '已办节点',
    'ProcessNode': '进行中节点',
    'ExceptionNode': '异常节点',
    'UnstartNode': '未开始',
    'WorkflowName': '流程名称',
    'Status': '状态',
    'StartTime': '开始时间',
    'FinishedTime': '结束时间',
    'BaseInfo': '基本信息',
    'NoFinishOriginator': '未完成的参与者',
    'ViewDetails': '查看详情',
    'ChooseAdjustType': '选择调整类型',
    'AdjustOriginator': '调整当前处理人',
    'CancelAllTask': '取消当前节点所有任务',
    'ActivateNodes': '激活其它节点',
    'AdjustNodeTips': '取消当前节点所有任务，流程会停滞；取消后管理员可以激活到其他节点',
    'notNodeTips': '当前无可用节点',
    'ChooseNode': '调整节点',
    'ChooseHandler': '选择处理人',
    'ClickChoose': '点击选择',
    'Null': '空',
    'Nothing': '无',
    'Cancel': '取消',
    'OK': '确定',
    'Ok&Del': '确定并删除',
    'Predictor': '预估处理人',
    'NoDetail': '暂无内容',
    'trust': '【{name}委托】',
    'trust2': '委托',
    'Person': '人',
    'Give': '给',
    'giveYou': '给你',
    'Of': '的',
    'NewWorkflow': '新建流程',
    'NewWorkflowTips': '赶紧新建属于你的流程吧',
    'ParamsSetting': '参数设置',
    'HistoryVersion': '历史版本',
    'ParamsSetting1': 'PC端发起',
    'ParamsSetting2': '移动端发起',
    'ParamsSetting3': '发起权限设置',
    'ParamsSetting4': '应用被停用后，发起权限设置失效，所有人都无法发起流程',
    'ParamsSetting5': '所有人可发起',
    'ParamsSetting6': '用户范围',
    'ParamsSetting7': '新增权限',
    'ParamsSetting8': '更新成功',
    'ParamsSetting9': '确定要删除用户权限？',
    'ParamsSetting10': '删除流程权限成功',
    'ParamsSetting11': '您无此部门/人员的管理范围，无法删除',
    'ParamsSetting12': '删除失败，权限已被删除',
    'ParamsSetting13': '请设置发起权限内容',
    'ParamsSetting14': '创建流程权限成功',
    'ParamsSetting15': '{num}条流程权限创建失败',
    'HistoryVersion1': '流程编码',
    'HistoryVersion2': '由于流程模拟运行会占用版本号，正式运行的版本号会出现不连续的情况',
    'HistoryVersion3': '查看',
    'SetPrivilege1': '流程运维特权人',
    'SetPrivilege2': '新建流程运维特权人',
    'SetPrivilege3': '编辑流程运维特权人',
    'SetPrivilege4': '用户范围',
    'SetPrivilege5': '流程运维范围',
    'SetPrivilege6': '流程操作',
    'SetPrivilege7': '作废流程',
    'SetPrivilege8': '结束流程',
    'SetPrivilege9': '删除流程',
    'SetPrivilege10': '节点操作',
    'SetPrivilege11': '调整当前处理人',
    'SetPrivilege12': '取消当前节点所有任务',
    'SetPrivilege13': '激活其他节点',
    'SetPrivilege14': '流程数据操作',
    'SetPrivilege15': '修改拥有者',
    'SetPrivilege16': '用户范围不能为空！',
    'SetPrivilege17': '流程运维范围不能为空！',
    'SetPrivilege18': '请确认是否删除，删除后会影响已在途的流程和新建流程！',
    'SetPrivilege19': '新增成功',
    'SetPrivilege20': '修改成功',
    'SetPrivilege21': '取消当前节点任务',
    'SetPrivilege22': '激活节点',
    'WorkflowState': {
        'Draft': '草稿',
        'Processing': '进行中',
        'Completed': '已完成',
        'Canceled': '已作废',
        'Exception': '异常',
    },
    'WorkflowActionStatus': {
        'Submit': '提交',
        'Submits': '提交',
        'Cancel': '作废',
        'Agree': '同意',
        'DisAgree': '不同意',
        'AdjustParticipant': '加签',
        'Assist': '协办',
        'Forward': '转办',
        'Reject': '驳回',
        'FinishInstance': '结束流程',
        'UnRead': '待阅',
        'Read': '已阅',
        'Circularize': '传阅',
        'Empty': '',
        'Revoke': '撤回',
        'BeCanceled': '被取消',
        'AutoCanceled': '自动取消',
        'ActivateActivity': '激活其他节点',
        'ADJUST_PARTICIPANT': '调整当前处理人',
        'CANCELED_ACTIVITY_WORKITEM': '取消节点所有任务',
        'MODIFY_OWNER': '修改拥有者',
    },
    'WorkItemStatus': {
        'NotStarted': '未启动',
        'Processing': '进行中',
        'Completed': '已完成',
        'Canceled': '被取消',
        'Draft': '草稿',
        'BeCanceled': '被取消',
    },
    'SubWorkItemStatus': {
        'NotStarted': '未启动',
        'Processing': '进行中',
        'Completed': '已完成',
        'Canceled': '已作废',
        'Exception': '流程异常',
        'BeCanceled': '被取消',
    },
    'workflow': require('@cloudpivot/common/locales/machine/zh-CN.json')
};
